/**
 * STORKKK Premium Mobile Sticky Add to Cart
 * File: assets/storkkk-sticky-atc.js
 */

if (!customElements.get('storkkk-sticky-atc')) {
  customElements.define('storkkk-sticky-atc', class StorkkkStickyATC extends HTMLElement {
    constructor() {
      super();
      this.productFormId = this.dataset.productFormId;
      this.variantTitleEl = this.querySelector('[data-sticky-variant-title]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.submitButton = this.querySelector('[data-sticky-submit]');
      this.submitText = this.querySelector('[data-sticky-submit-text]');
      this.observer = null;
    }

    connectedCallback() {
      this.initIntersectionObserver();
      this.listenToVariantChanges();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    /**
     * Sets up IntersectionObserver on the main product buy buttons.
     */
    initIntersectionObserver() {
      const targetElement = document.querySelector(`.product-form[id="${this.productFormId}"]`) 
        || document.querySelector('.product-form__submit')
        || document.querySelector('[data-type="add-to-cart-form"]');

      if (!targetElement) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // When the main buy button leaves the viewport top, show sticky ATC
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }, {
        threshold: 0,
        rootMargin: '-50px 0px 0px 0px'
      });

      this.observer.observe(targetElement);
    }

    show() {
      this.classList.add('is-visible');
      this.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
    }

    /**
     * Listens to Dawn's native variant change events to update price and state.
     */
    listenToVariantChanges() {
      document.addEventListener('variant:change', this.onVariantChange.bind(this));
      
      // Secondary listener for theme-check or custom standard events in modified Dawn themes
      const variantPicker = document.querySelector('variant-selects, variant-radios');
      if (variantPicker) {
        variantPicker.addEventListener('change', () => {
          // Small tick delay to allow Dawn's JS to render update first
          setTimeout(() => this.syncFromDom(), 50);
        });
      }
    }

    /**
     * Fired when standard Dawn publishes variant selection event.
     */
    onVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) return;

      this.updateState(variant);
    }

    /**
     * Fallback to DOM parsing for modified variant pickers.
     */
    syncFromDom() {
      const priceSource = document.querySelector('.price .price-item--last') 
        || document.querySelector('.price-item--regular');
      const submitSource = document.querySelector('.product-form__submit');

      if (priceSource && this.priceEl) {
        this.priceEl.innerHTML = priceSource.innerHTML;
      }

      if (submitSource) {
        const isDisabled = submitSource.hasAttribute('disabled');
        const submitText = submitSource.querySelector('span')?.textContent || '';

        this.updateButtonState(isDisabled, submitText);
      }
    }

    updateState(variant) {
      // Update Title
      if (this.variantTitleEl) {
        this.variantTitleEl.textContent = variant.title && !variant.title.includes('Default') ? variant.title : '';
      }

      // Update Price
      if (this.priceEl && variant.price) {
        this.priceEl.textContent = this.formatMoney(variant.price);
      }

      // Update Availability / Sold Out state
      const isAvailable = variant.available;
      const buttonText = isAvailable 
        ? (window.variantStrings?.addToCart || 'Add to Cart') 
        : (window.variantStrings?.soldOut || 'Sold Out');

      this.updateButtonState(!isAvailable, buttonText);
    }

    updateButtonState(disabled, text) {
      if (!this.submitButton) return;

      if (disabled) {
        this.submitButton.setAttribute('disabled', 'true');
      } else {
        this.submitButton.removeAttribute('disabled');
      }

      if (this.submitText && text) {
        this.submitText.textContent = text;
      }
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return `$${(cents / 100).toFixed(2)}`;
    }
  });
}